const Main = () => {
  return (
    <div class="text-6xl h-96 w-full mt-16">
      <div class=" p-8 pt-12">
        <h1 class="text-5xl">Hi, My name is Jay</h1>
        <h2 class="mt-6">I'm a Full-Stack Developer</h2>
        <hr class="mt-6 w-96" />
      </div>
    </div>
  );
};

export default Main;
